import Swiper from 'swiper';
import { Pagination, Navigation, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

var sliders = document.querySelectorAll(".media.swiper");
sliders.forEach((el) => {
	const swiper = new Swiper(`#${el.id}`, {
		modules: [Pagination, Navigation, A11y],
		pagination: {
			clickable: true,
			el: `#${el.id}-pagination`,
		},
		navigation: {
			nextEl: `#${el.id}-next`,
			prevEl: `#${el.id}-prev`,
		}
	});
});

sliders = document.querySelectorAll(".tab-content-media .swiper");
sliders.forEach((el) => {
	const swiper = new Swiper(`#${el.id}`, {
		modules: [Pagination, Navigation, A11y],
		// loop: true,
		pagination: {
			clickable: true,
			el: `#${el.id}-pagination`,
		},
		navigation: {
			nextEl: `#${el.id}-next`,
			prevEl: `#${el.id}-prev`,
		}
	});
	let externalControls = document.querySelectorAll(`#${el.id}-external .control`);
	let controlDescription = document.getElementById(`${el.id}-active-description`);
	swiper.on('realIndexChange', function () {
		externalControls.forEach((control) => {
			control.classList.remove('active');
			if (control.dataset.target == swiper.realIndex) {
				control.classList.add('active');
				let nodes = control.getElementsByTagName('span');
				controlDescription.innerText = nodes[0].innerText;
			}
		});
	});
	externalControls.forEach((control) => {
		control.addEventListener("click", function () {
			swiper.slideTo(control.dataset.target);
			// when slides are allowed to loop, their index constantly changes so we have to match against its data index to find its current index
			// leaving this in here in case they want to loop
			// let slides = swiper.slides;
			// slides.forEach((slide, i) => {
			// 	if (slide.dataset.swiperSlideIndex == control.dataset.target) {
			// 		swiper.slideTo(i);
			// 	}
			// });
		});
	});
});

$(document).ready(function () {

	$('#collection-description').fitVids();

	var sessionKey = 'lo' + $('.page-header').data('collection');
	var savedState = sessionStorage.getItem(sessionKey);

	var setFilterOptions = function () {
		// show/hide filter options
		$('.filter-option').each(function () {
			var $parentEl = $(this).closest('li');
			// might need to show after an AJAX update, so reset to shown as default
			$parentEl.addClass('shown');
			// hide if no products use this filter
			if ($('.' + $(this).data('hook')).length < 1) {
				$parentEl.removeClass('shown');
			}
		});

		// reset before hiding things
		$('.filter-group').addClass('shown');
		// $('.filter-options').addClass('shown');
		// $('.filter-toggle').addClass('shown');

		// hide filter groups
		$('.filter-options').each(function () {
			if ($(this).find('.shown').length < 2) {
				// $('[href="#' + $(this).attr('id') + '"]').removeClass('shown');
				// $(this).removeClass('shown');
				$(this).closest('.filter-group').removeClass('shown');
			}
		});

		// nothing to filter with, hide the whole thing
		if ($('.filter-group.shown').length < 1) {
			$('#filters').hide();
		} else {
			$('#filters').show();
		}
	};

	// setup content IDs for GTM
	var contentIds = $('#content-ids').text();
	var allContentCategories = [];

	var reportCollection = function (ids, categories) {
		var dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'View Collection',
			'contentIds': ids,
			'contentCategories': categories.join(',')
		});
	}

	// go get other pages so we can filter everything at once 
	if ($('.ajax-pagination').length) {
		$('.ajax-pagination a').each(function () {
			if ($(this).hasClass('current')) return;
			$.ajax({
				async: false, // make sure we get the products back in the correct order
				url: $(this).attr('href'),
				success: function (data, textStatus, jqXHR) {
					// insert the product families from the requested page
					var $productFamilies = $(data).find('#MainContent .product-family');
					var $insertPoint = $('#results');
					$productFamilies.appendTo($insertPoint);
					contentIds += $(data).find('#content-ids').text();
				},
				complete: function () {
					/*
					  clean up families in case a family is split between pages
					  */

					// grab all of the names
					var allFamilyNames = [];
					$('.product-family').each(function () {
						allFamilyNames.push($(this).data('family-name'));
						allContentCategories.push($(this).data('content-category'));
					});

					// find duplicates, this indicates a split
					var duplicates = [];
					allFamilyNames.forEach(function (element, index) {
						// Find if there is a duplicate or not
						if (allFamilyNames.indexOf(element, index + 1) > -1) {
							// Find if the element is already in the result array or not
							if (duplicates.indexOf(element) === -1) {
								duplicates.push(element);
							}
						}
					});

					// move the second set into the first
					if (duplicates.length) {
						for (var i = 0; i < duplicates.length; i++) {
							var $firstSet = $('[data-family-name="' + duplicates[i] + '"]').eq(0);
							var $secondSet = $('[data-family-name="' + duplicates[i] + '"]').eq(1);
							var $productsToMove = $secondSet.find('.f-hook');
							$productsToMove.detach().appendTo($firstSet.find('.product-row'));
							$secondSet.remove();
						};
					}

					// update our filter options
					setFilterOptions();

					// update side scrolling rows
					LS.productRowInit(true);
					LS.draggableScrollbar();
				}
			});
		});
		// report the final list to GTM
		var contentCategories = [];
		allContentCategories.forEach(function (element, index) {
			if (contentCategories.indexOf(element) === -1) {
				contentCategories.push(element);
			}
		});
		contentIds = contentIds.replace(/,\s*$/, ""); // remove the last comma
		// reportCollection(contentIds,contentCategories);
	} else {
		// no pagination, so send the list right away
		$('.product-family').each(function () {
			allContentCategories.push($(this).data('content-category'));
		});
		contentIds = contentIds.replace(/,\s*$/, ""); // remove the last comma
		// reportCollection(contentIds,allContentCategories);
	}


	// setup filter options
	// setFilterOptions();

	var $activeFilters = $('#active-filters');

	$('.filter-option').on('click', function (e) {
		//   e.preventDefault();
		$(this).toggleClass('selected');

		// assume nothing matches
		$('.f-hook').addClass('hidden');
		$('#filter-alert').hide();

		// rebuild arrays of selections
		var allActiveFilters = [];
		$('.filter-options').each(function () {
			var $filterGroup = $(this);
			if ($filterGroup.find('.filter-option.selected').length > 0) {
				var activeGroupFilters = [];
				$filterGroup.find('.filter-option.selected').each(function () {
					activeGroupFilters.push($(this).data('hook'));
				});
				allActiveFilters.push(activeGroupFilters);
			}
		});

		if ($('.filter-option.selected').length < 1) {
			// no active filters, so show everything
			$('.page-header').removeClass('has-active-filters');
			$('.f-hook').removeClass('hidden');
			sessionStorage.removeItem(sessionKey);
		} else {
			// show results
			$('.f-hook').each(function () {
				var itemClasses = $(this).attr('class').split(' ');
				var groupMatches = 0;
				// loop over each filter group
				for (var f = 0; f < allActiveFilters.length; f++) {
					// loop over each option in the group
					for (var k = 0; k < allActiveFilters[f].length; k++) {
						// if this option appears somewhere in the product's classes, we've matched the group
						if (itemClasses.indexOf(allActiveFilters[f][k]) > -1) {
							groupMatches++;
							break; // don't over count
						}
					}
				};
				// compare the number of matches we found to the number of groups with active filters
				// if they're equal then this item satisfies each group requirement somehow
				if (groupMatches == allActiveFilters.length) {
					$(this).removeClass('hidden');
				}
			});

			// show our active filters element
			$('.page-header').addClass('has-active-filters');

			// no results
			if ($('.f-hook').length == $('.f-hook.hidden').length) {
				$('#filter-alert').fadeIn();
			}
		}

		// maybe hide the product group
		$('.product-family').each(function () {
			if ($(this).find('.f-hook').length == $(this).find('.f-hook.hidden').length) {
				$(this).hide();
			} else {
				$(this).fadeIn();
			}
		});

		// redo the scrolling areas
		LS.productRowInit(false);
	});
	$('#reset-filters').on('click', function (e) {
		e.preventDefault();
		$('.filter-option').removeClass('selected');
		$('.page-header').removeClass('has-active-filters');
		$('.f-hook').removeClass('hidden');
		$('.product-family').fadeIn();
		$('.pagination').show();
		$('#filter-alert').hide();
		sessionStorage.removeItem(sessionKey);
		LS.productRowInit(false);
	});

	$('#filters-trigger, #open-filters').on('click', function (e) {
		e.preventDefault();
		$('body').addClass('filters-open');
		window.returnFocusTo = $(this);
		LS.trapFocus('#filters');
	});
	$('#filters .panel-close').on('click', function (e) {
		e.preventDefault();
		$('body').removeClass('filters-open');
		LS.returnFocus();
	});

	if ($(window).width() >= LS.desktopBreakpoint) {
		$('#filters').removeAttr('role tabindex aria-modal role aria-labelledby');
	}

	function closeDiscoverTabs(){
		$('#discover-tabs').removeClass('shown');
		$('body').removeClass('discover-tabs-shown');
		LS.returnFocus();
	}

	$('.discover-tabs-trigger').on('click', function (e) {
		e.preventDefault();
		let $targetWindow = $($(this).data('target'));
		window.returnFocusTo = $(this);
		$targetWindow.addClass('shown');
		$targetWindow.find(`[data-handle="${$(this).data('handle')}"]`).click();
		$targetWindow.focus();
		LS.trapFocus($targetWindow.selector, false);
		$('body').addClass('discover-tabs-shown');
	});

	$('#discover-tabs .close').on('click', function(e){
		e.preventDefault();
		closeDiscoverTabs();
	});

	$('body').on('keyup', function (e) {
        if (LS.isEscape(e)) {
            closeDiscoverTabs();
			$('body').removeClass('filters-open');
			LS.returnFocus();
        }
    });

	$('#filters-overlay').on('click', function(e){
		$('body').removeClass('filters-open');
	});

	function setSortingWidth(){
		let $el = $('#collection-sorting');
		let optionText = $el.find(`[value="${$el.val()}"]`).text();
		let $measureEl = $(`<span>${optionText}</span>`);
		$measureEl.insertAfter($el);
		let w = $measureEl.width() + 20; // int to add space for the caret
		$measureEl.remove();
		$el.css('width', w);
	}
	setSortingWidth();

	$('#collection-sorting').on('change', function(){
		window.location = window.location.origin + window.location.pathname + '?sort_by=' + $('#collection-sorting').val();
	});

	$('.filter-group-toggle').on('click', function(e){
		e.preventDefault();
		if($(this).attr('aria-expanded') === 'true'){
			$(this).attr('aria-expanded', false);
		} else {
			$(this).attr('aria-expanded', true);
		}
	});

	// https://codepen.io/predragdavidovic/pen/mdpMoWo
	function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
		const [from, to] = getParsed(fromInput, toInput);
		fillSlider(fromInput, toInput, '#D9D9D9', '#000', controlSlider);
		if (from > to) {
			fromSlider.value = to;
			fromInput.value = to;
		} else {
			fromSlider.value = from;
		}
	}
		
	function controlToInput(toSlider, fromInput, toInput, controlSlider) {
		const [from, to] = getParsed(fromInput, toInput);
		fillSlider(fromInput, toInput, '#D9D9D9', '#000', controlSlider);
		setToggleAccessible(toInput);
		if (from <= to) {
			toSlider.value = to;
			toInput.value = to;
		} else {
			toInput.value = from;
		}
	}

	function preventLabelCrash(fromSlider, toSlider){
		$('#fromRangeLabel, #toRangeLabel').toggleClass('prevent', (toSlider.value - fromSlider.value) < 60);
	}

	function setFromLabel(currentVal, fromSlider, toSlider){
		$('#fromRangeLabel').css('left', (currentVal / toSlider.getAttribute('max')) * 100 + '%').text('$' + currentVal);
		$('#fromRangeLabel').toggleClass('active', currentVal > 20);
		preventLabelCrash(fromSlider, toSlider);
	}
	function setToLabel(currentVal, fromSlider, toSlider){
		$('#toRangeLabel').css('left', (currentVal / toSlider.getAttribute('max')) * 100 + '%').text('$' + currentVal);
		$('#toRangeLabel').toggleClass('active', currentVal < (toSlider.getAttribute('max') - 20));
		preventLabelCrash(fromSlider, toSlider);
	}
	
	function controlFromSlider(fromSlider, toSlider, fromInput) {
	  const [from, to] = getParsed(fromSlider, toSlider);
	  let currentVal;
	  fillSlider(fromSlider, toSlider, '#D9D9D9', '#000', toSlider);
	  if (from > to) {
		fromSlider.value = to;
		fromInput.value = to;
		currentVal = to;
	  } else {
		fromInput.value = from;
		currentVal = from;
	  }
	  setFromLabel(currentVal, fromSlider, toSlider);
	}
	
	function controlToSlider(fromSlider, toSlider, toInput) {
	  const [from, to] = getParsed(fromSlider, toSlider);
	  let currentVal;
	  fillSlider(fromSlider, toSlider, '#D9D9D9', '#000', toSlider);
	  setToggleAccessible(toSlider);
	  if (from <= to) {
		toSlider.value = to;
		toInput.value = to;
		currentVal = to;
	  } else {
		toInput.value = from;
		toSlider.value = from;
		currentVal = from;
	  }
	 setToLabel(currentVal, fromSlider, toSlider);
	}
	
	function getParsed(currentFrom, currentTo) {
	  const from = parseInt(currentFrom.value, 10);
	  const to = parseInt(currentTo.value, 10);
	  return [from, to];
	}
	
	function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
		if(!from || !to) return;
		const rangeDistance = to.max-to.min;
		const fromPosition = from.value - to.min;
		const toPosition = to.value - to.min;
		controlSlider.style.background = `linear-gradient(
		  to right,
		  ${sliderColor} 0%,
		  ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
		  ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
		  ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, 
		  ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
		  ${sliderColor} 100%)`;
	}
	
	function setToggleAccessible(currentTarget) {
	  const toSlider = document.querySelector('#toSlider');
	  if(!toSlider) return;
	  if (Number(currentTarget.value) <= 0 ) {
		toSlider.style.zIndex = 2;
	  } else {
		toSlider.style.zIndex = 0;
	  }
	}
	
	const fromSlider = document.querySelector('#fromSlider');
	const toSlider = document.querySelector('#toSlider');
	const fromInput = document.querySelector('#fromInput');
	const toInput = document.querySelector('#toInput');
	fillSlider(fromSlider, toSlider, '#D9D9D9', '#000', toSlider);
	setToggleAccessible(toSlider);
	if(fromSlider){
		setFromLabel(fromSlider.value, fromSlider, toSlider);
		fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
	}
	if(toSlider){
		setToLabel(toSlider.value, fromSlider, toSlider);
		toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
	}
	if(fromInput){
		fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
	}
	if(toInput){
		toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);
	}
	
});